// extracted by mini-css-extract-plugin
export default {"loading-overlay":"LoadingOverlay-module__loading-overlay___KORPE"};